import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	overlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		zIndex: theme.zIndex.drawer + 1,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		color: '#fff',
	},
}));

function BackdropLoading() {
	const classes = useStyles();
	return (
		<div className={classes.overlay} aria-hidden="false">
			<CircularProgress color="inherit" />
		</div>
	);
}

export default BackdropLoading;
